module.exports = __webpack_public_path__ + "static/media/tr.ed6d5f37.svg";